"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Permission = void 0;

class Permission {
  constructor() {
    this._id = void 0;
    this.name = void 0;
    this.id = void 0;
    this.description = void 0;
    this.context = void 0;
  }

  static fromJson(json) {
    const permission = new Permission(); // eslint-disable-next-line no-underscore-dangle

    permission._id = json._id;
    permission.name = json.name;
    permission.id = json.id;
    permission.description = json.description;
    permission.context = json.context;
    return permission;
  }

}

exports.Permission = Permission;